(async function () {
  const { addDrawer } = await window.shimport('orbit-drawer');

  const moreButton = document.getElementById('orbit-more-button');

  const moreDrawerContent = document.getElementById('orbit-more-drawer');

  const moreDrawer = addDrawer(
    moreButton,
    moreDrawerContent,
    async (isOpen, isMouseUser) => {
      if (isOpen && !isMouseUser) {
        const visibleNav = Array.from(
          document.querySelectorAll('#orbit-more-drawer ul')
        ).filter(
          (s) =>
            window.getComputedStyle(s).getPropertyValue('display') !== 'none'
        )[0];
        const visibleNavLinks = Array.from(
          visibleNav.getElementsByTagName('li')
        ).filter(
          (s) =>
            window.getComputedStyle(s).getPropertyValue('display') !== 'none'
        );
        if (visibleNavLinks.length > 0) {
          const firstLink = visibleNavLinks[0].querySelector('a');
          firstLink.focus();
        }
      }
    }
  );

  const moreDrawerCloseButton = document.getElementsByClassName(
    'orbit-more-drawer-close'
  )[0];

  moreDrawerCloseButton.addEventListener('click', (e) => {
    moreDrawer.close(e);
  });
})();
